module.exports = __webpack_public_path__ + "static/media/icon_check_no.d1410894.svg";